import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { fetch, updateQueryStringParams } from '../../utils';
export var fetchMeta = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(publicationBasicUrl, publicationId) {
    var _publicationId$match, _publicationId$match2, country, id, metaUrl, descriptorUrl, _yield$Promise$all, _yield$Promise$all2, meta, descriptor, activated, expired, baseUrl, _ref2, isolateFirstPage, numberOfPages, pageDescriptors, pagesBundles;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _publicationId$match = publicationId.match(/([a-z]{2}_[a-z]{2})_([0-9]+)$/), _publicationId$match2 = _slicedToArray(_publicationId$match, 3), country = _publicationId$match2[1], id = _publicationId$match2[2];
          metaUrl = "".concat(publicationBasicUrl, "/publication/").concat(publicationId);
          descriptorUrl = "".concat(publicationBasicUrl, "/publication_pages/").concat(country, "/").concat(id, "/1");
          _context.next = 5;
          return Promise.all([fetch(metaUrl), fetch(descriptorUrl)]);
        case 5:
          _yield$Promise$all = _context.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          meta = _yield$Promise$all2[0];
          descriptor = _yield$Promise$all2[1];
          activated = meta.activated, expired = meta.expired, baseUrl = meta.baseURL;
          _ref2 = (descriptor === null || descriptor === void 0 ? void 0 : descriptor.publicationDescriptor) || {}, isolateFirstPage = _ref2.firstPageIsCoverPage, numberOfPages = _ref2.numberOfPages, pageDescriptors = _ref2.pageDescriptors;
          pagesBundles = pageDescriptors === null || pageDescriptors === void 0 ? void 0 : pageDescriptors.reduce(function (acc, _ref3) {
            var bundlePart = _ref3.bundlePart,
              bundlePath = _ref3.bundlePath;
            return _objectSpread(_objectSpread({}, acc), {}, {
              [bundlePart]: updateQueryStringParams(bundlePath, 'format', 'all')
            });
          }, {});
          return _context.abrupt("return", {
            activated,
            expired,
            baseUrl,
            isolateFirstPage,
            numberOfPages,
            pagesBundles
          });
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchMeta(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();